export function* loadPerChunk(list, step = 5) {
  for (let i = 0; i < list.length; i += 5) {
    yield list.slice(i, i + step);
  }
}
export const getResourceChunks = (list) => {
  const resource = []
  const res = loadPerChunk(list);
  let result = res.next();
  while (!result.done) {
    resource.push(result.value)
    result = res.next();
  }
  return resource;
}
